import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import ScrollToTop from './utility/ScrollToTop.ts';
import { persistor, store } from './redux/store.ts';
import { PersistGate } from 'redux-persist/integration/react';
import { NotificationProvider } from './context/NotificationContext.tsx';

// import './js/main.js';

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <NotificationProvider>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={import.meta.env.VITE_PUBLIC_URL}>
          <Toaster position="top-left" />
          <ScrollToTop />
          <App />
        </BrowserRouter>
      </PersistGate>
    </NotificationProvider>
  </Provider>,
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration.scope);
    })
    .catch((err) => console.error('Service Worker registration failed:', err));
}
